export const scrollToPageTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

export const scrollToContactSection = () => {
  const section = document.getElementById('contact')
  if (!section) return false

  section.scrollIntoView({ behavior: 'smooth', block: 'start' })
  return true
}
